import { commonAxios } from "../../Global/CommonAxios";
import { setAlert } from "./AlertActions";


export const fetchAdminUserActivatlistAction = (url, data, setUserActivity, setLoader, loader) => (dispatch, getState) => {

    commonAxios(url, data, dispatch, getState().auth.token)
        .then((res) => {

            if (res.status) {
                setUserActivity(res.data.list)

            }
            else {

                dispatch(setAlert(res.msg, "danger"));
            }
            setLoader({
                ...loader,
                fetch: false
            })
        }).catch((err) => {
            console.log(err)
            setLoader({
                ...loader,
                fetch: false
            })
        })
}
export const onExportUserCsv = (url, data, loader, setLoader) => (dispatch, getState) => {
    commonAxios(url, data, dispatch, getState().auth.token)
        .then((res) => {
            if (res.status) {
                let fileDownload = document.createElement("a");
                fileDownload.href = res.data;
                fileDownload.download = "results.csv";
                fileDownload.click();
            } else {
                dispatch(setAlert(res.msg, "danger"));
            }
            setLoader({
                ...loader,
                export: false
            });
        }).catch((err) => {
            console.log(err.message);
            dispatch(setAlert(err.message, "danger"));
            setLoader({
                ...loader,
                export: false
            });
        });
}



export const fetchAdminplanAction = (url, setUserActivity, setLoader, loader) => (dispatch, getState) => {

    commonAxios(url, {}, dispatch, getState().auth.token)
        .then((res) => {
            if (res.status) {
                setUserActivity(res.data)
            }
            else {
                dispatch(setAlert(res.msg, "danger"));
            }
            setLoader({
                ...loader,
                fetch: false
            })
        }).catch((err) => {
            console.log(err)
            setLoader({
                ...loader,
                fetch: false
            })
        })
}
export const addAdminPlanAction = (url, data, loader, setLoader, fetchData, handleClose) => (dispatch, getState) => {

    commonAxios(url, data, dispatch, getState().auth.token)
        .then((res) => {
            if (res.status) {
                fetchData()
                handleClose()
                dispatch(setAlert(res.msg, "success"));
            }
            else {
                dispatch(setAlert(res.msg, "danger"));
            }
            handleClose()
            setLoader({
                ...loader,
                update: false
            })
        }).catch((err) => {
            console.log(err)
            setLoader({
                ...loader,
                update: false
            })
        })
}
export const deleteAdminPlanAction = (url, data, loader, setLoader, fetchData) => (dispatch, getState) => {

    commonAxios(url, data, dispatch, getState().auth.token)
        .then((res) => {
            if (res.status) {
                fetchData()
                dispatch(setAlert(res.msg, "success"));
            }
            else {
                dispatch(setAlert(res.msg, "danger"));
            }
            setLoader({
                ...loader,
                delete: false
            })
        }).catch((err) => {
            console.log(err)
            setLoader({
                ...loader,
                delete: false
            })
        })
}